import { Box } from 'components/Box/Box';
import { H2 } from 'components/Text/H2';
import { Text } from 'components/Text/Text';
import { useI18n } from 'i18n/hooks/useI18n';
import type { ApiOrg } from 'modules/listing/orgs/api/types/ApiOrg';
import { getCityStateString } from 'utils/address/getCityStateString';
import { monthAndYear } from 'utils/date';

type Props = {
  org: ApiOrg;
};

export function ViewOrgPageSidebarTitle({ org }: Props) {
  const { i18n, locale } = useI18n();

  return (
    <Box display="flex" flexDirection="column">
      <H2 styleAs="h3" m="0">
        {org.name}
      </H2>
      <Box my="4px">
        {org.address && <>{getCityStateString(i18n, org.address)}</>}
      </Box>
      <Text
        display={['inline-block', 'inline-block', 'inline-block', 'block']}
        color="lightContentGrey"
      >
        {i18n('Joined in %(monthAndYear)s', {
          monthAndYear: monthAndYear({ date: org.created, locale }),
        })}
      </Text>
    </Box>
  );
}
